import { useState } from "react";
import { Link } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";
import { Sparkles, ArrowRight, X } from "@/icons";
import { EASE } from "@/animations/motion";

/** Slim, dismissible announcement bar sitting atop the header. */
export function AnnouncementBar() {
  const [open, setOpen] = useState(true);

  return (
    <AnimatePresence initial={false}>
      {open && (
        <motion.div
          initial={{ height: 0, opacity: 0 }}
          animate={{ height: "auto", opacity: 1 }}
          exit={{ height: 0, opacity: 0 }}
          transition={{ duration: 0.3, ease: EASE }}
          className="overflow-hidden bg-secondary text-white"
          data-testid="announcement-bar"
        >
          <div className="relative mx-auto flex max-w-[1240px] items-center justify-center gap-2 px-5 py-2 text-center text-xs sm:text-sm">
            <Sparkles className="hidden h-3.5 w-3.5 text-accent sm:inline" />
            <span className="text-slate-300">
              New: AI-assisted product sprints now available.
            </span>
            <Link
              to="/contact"
              className="inline-flex items-center gap-1 font-medium text-white underline-offset-4 hover:underline"
            >
              Book a slot <ArrowRight className="h-3 w-3" />
            </Link>
            <button
              type="button"
              aria-label="Dismiss announcement"
              data-testid="announcement-dismiss"
              onClick={() => setOpen(false)}
              className="absolute right-4 inline-flex h-6 w-6 items-center justify-center rounded-full text-slate-400 transition-colors hover:bg-white/10 hover:text-white"
            >
              <X className="h-3.5 w-3.5" />
            </button>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
